<template>
  <div :class="$style.h5sdk">
    <!-- 支付 -->
    <!-- <Charge v-if="userState.chargeVisible" @close="closeChargeWindow"></Charge> -->
    <!-- 应用宝登录框 -->
    <!-- <YybLogin v-if="userState.yybLoginVisible"></YybLogin> -->
    <!-- 游戏frame -->
    <iframe
      :class="$style.gameFrame"
      name="gameFrame"
      :src="userState.game_url"
    ></iframe>
  </div>
</template>
<script>
import Charge from '@/components/charge/Charge'

import { mapState } from 'vuex';
import {
  thirdPartyLogins,
  registJSInitial,
  innerPurchaseFunctionSuc,
  closeOrderFrame,
  checkOrderState,
} from '@/bridge/AppJsBridge';

export default {
  data() {
    return {
    }
  },
  mounted() {
    this.$store.dispatch("handle/handleH5ThirdPlatform", this.$route.query);
    this.$store.dispatch('user/getCacheState');
    this._bridgeInit();
  },
  computed: {
    ...mapState({
      userState: state => state.user,
      loginStatus: state => state.user.login_status,
      gameSrc: state => state.user.game_url
    })
  },
  components: {
    // Charge,
  },
  methods: {
    _bridgeInit() {
      // 初始化客户端传过来的信息
      registJSInitial(async (e, cb) => {
        console.log('--- registJSInitial start ---')
        // ios h5通过链接获取设备参数，不会进这里
        let data = JSON.parse(e);
        const { jsDataStorage, third_sdk_status } = data;

        // 存储传过来的信息
        this.$store.commit('user/CHANGE_STATE', {
          sdk_version: data.sdk_version,
          device_info: data.attributeReportParams,
          appkey: data.jh_app_id,
          channel: data.jh_channel,
          extra_data: JSON.stringify(data.extra_data),
          game_version: data.game_version,
          login_status: jsDataStorage || '',
          third_sdk_status: third_sdk_status || ''
        });

        // 缓存信息
        const cacheList = [
          'login_status',
          'sdk_version',
          'device_info',
          'appkey',
          'channel',
          'extra_data',
          'game_version',
          'third_sdk_status'
        ];
        this.$store.dispatch('user/cacheState', cacheList);

        this.$store.dispatch('user/getYsdkStatus', 1);
      });
      thirdPartyLogins((e, cb) => {
        console.log('--- third login start ---')
        let data = JSON.parse(e);
        if (data.isHuaWei) {
          // 针对华为审核不能存在第三方账号体系做处理
          this.$store.dispatch('user/huaweiThirdLogin');
        } else {
          this.$store.commit('user/CHANGE_STATE', { username: data.user_name, password: data.origncv });
          this.$store.dispatch('user/login', true);
          this.$store.dispatch('thirdMsg/monitorInit')
        }
      });
      // 应用宝内购
      innerPurchaseFunctionSuc(async (e, cb) => {
        console.log('--- 应用宝内购 ---')
        this.$store.commit('pay/CHANGE_STATE', { yyb_info: JSON.parse(e) });
        this.$store.dispatch('pay/yybInnerPay')
        cb('yyb_Success');
      });
    },
  }
}
</script>

<style lang="scss" module>
.h5sdk {
  width: 100%;
  height: 100%;
  .gameFrame {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    background: #000000;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border: 0;
  }

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
  }
}
</style>